var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 400,
    viewBox: "0 0 353 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1306_2019)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 353,
    height: 400,
    rx: 176.5,
    fill: "#718AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 200H353V223.5C353 320.978 273.978 400 176.5 400C79.0217 400 0 320.978 0 223.5V200Z",
    fill: "#95AAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1306_2019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352.779,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillBlue);
export default __webpack_public_path__ + "static/media/pill_blue.9e91d498707d184eebc30b72f1c8ef3b.svg";
export { ForwardRef as ReactComponent };